import { ColorClassnameMap, VariantClassnameMap } from './types';

export const variantClassname: VariantClassnameMap = {
  text: 'disabled:text-gray-400',
  outlined: 'border disabled:opacity-30',
  contained: 'text-white-primary disabled:opacity-30',
};

export const colorClassname: ColorClassnameMap = {
  black: {
    text: '',
    contained: '',
    outlined:
      'border-black-primary text-black-primary hover:bg-black-primary/10 bg-white-primary',
  },
  info: {
    text: 'text-cyan-500 hover:bg-cyan-50',
    contained: 'bg-cyan-500 hover:bg-cyan-600',
    outlined: 'border-cyan-500 text-cyan-500 hover:bg-cyan-50',
  },
  success: {
    text: 'text-green-500 hover:bg-green-50',
    contained: 'bg-green-500 hover:bg-green-600',
    outlined: 'border-green-500 text-green-500 hover:bg-green-50',
  },
  secondary: {
    text: '',
    outlined: '',
    contained:
      'text-white-primary bg-blue-secondary-primary hover:bg-blue-secondary-hover active:bg-blue-secondary-active',
  },
  warning: {
    text: 'text-yellow-500 hover:bg-yellow-50',
    contained: 'bg-yellow-500 hover:bg-yellow-600',
    outlined: 'border-yellow-500 text-yellow-500 hover:bg-yellow-50',
  },
  primary: {
    contained: 'bg-blue-primary hover:bg-blue-hover active:bg-blue-active',
    text: 'text-blue-primary bg-transparent hover:text-blue-hover active:text-blue-active',
    outlined:
      'border-blue-primary bg-white-primary text-blue-primary hover:bg-blue-secondary-primary active:bg-blue-secondary-hover',
  },
  error: {
    text: 'text-red-primary hover:bg-red-50',
    contained:
      'text-white-primary bg-red-primary hover:bg-red-hover active:bg-red-active',
    outlined:
      'border-red-primary text-red-primary bg-red-secondary-primary hover:bg-red-secondary-hover active:bg-red-secondary-active active:text-white-primary',
  },
};
